import { useQuery } from '@tanstack/react-query';
import { domainService } from '../services/domainService';
import type { Domain } from '../types/domain.types';

const EMPTY: Domain[] = [];

/**
 * Load all domains for the authenticated customer.
 *
 * Phase 6: migrated to TanStack Query, which the original TODO here anticipated
 * ("when TanStack Query is adopted, replace with useQuery"). Exported shape is
 * unchanged so callers did not need touching.
 */
export function useDomains() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['domains', 'list'],
    queryFn: () => domainService.list(),
  });

  return {
    data: data ?? EMPTY,
    isLoading,
    error: (error as Error | null) ?? null,
    refetch,
  };
}
